<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">
              Consulta de Transportadoras Regularizadas (Fretamento e
              Turismo)
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-form ref="form" v-model="form.valid" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-select
                      filled
                      rounded
                      dense
                      :items="filters"
                      item-text="name"
                      item-value="key"
                      label="Filtrar por"
                      v-model="form.filter"
                    ></v-select>
                    <v-text-field
                      v-if="form.filter === 'CNPJ'"
                      type="text"
                      label="CNPJ *"
                      placeholder="Digite o CNPJ da transportadora"
                      v-model="formattedCnpj"
                      :rules="[rules.required]"
                      maxlength="18"
                      filled
                      rounded
                      dense
                      name="cnpj"
                      id="cnpj"
                    ></v-text-field>
                    <v-text-field
                      v-if="form.filter === 'PLACA'"
                      type="text"
                      label="PLACA *"
                      placeholder="Digite a PLACA de um veículo da transporadora"
                      v-model="form.term"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      name="placa"
                      id="placa"
                      style="text-transform: uppercase"
                      @input="form.term = form.term ? form.term.toUpperCase() : form.term"
                    ></v-text-field>
                    <v-autocomplete
                      v-if="form.filter === 'RAZAO_SOCIAL'"
                      v-model="form.term"
                      :items="transportadoraItems"
                      item-text="razaoSocial"
                      item-value="razaoSocial"
                      label="RAZÃO SOCIAL *"
                      placeholder="Digite a RAZÃO SOCIAL da transporadora"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      name="razaoSocial"
                      id="razaoSocial"
                    ></v-autocomplete>
                    <!-- <v-text-field
                      v-if="form.filter==='RAZAO_SOCIAL'"
                      type="text"
                      label="RAZÃO SOCIAL *"
                      placeholder="Digite a RAZÃO SOCIAL da transporadora"
                      v-model="form.term"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      name="razaoSocial"
                      id="razaoSocial"
                    ></v-text-field>-->
                    <v-autocomplete
                      v-if="form.filter === 'NOME_FANTASIA'"
                      v-model="form.term"
                      :items="transportadoraItems"
                      item-text="nomeFantasia"
                      item-value="nomeFantasia"
                      label="NOME FANTASIA *"
                      placeholder="Digite O NOME FANTASIA da transporadora"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      name="nomeFantasia"
                      id="nomeFantasia"
                    ></v-autocomplete>
                    <!-- <v-text-field
                      v-if="form.filter==='NOME_FANTASIA'"
                      type="text"
                      label="NOME FANTASIA *"
                      placeholder="Digite O NOME FANTASIA da transporadora"
                      v-model="form.term"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                      name="nomeFantasia"
                      id="nomeFantasia"
                    ></v-text-field>-->
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12" class="pt-0">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="form.recaptcha"
                      :rules="[rules.required]"
                      class="recaptcha-input"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12" class="pt-0">
                    <v-btn depressed block large color="primary" type="submit">Consultar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
                <span>Consultando transportadora, aguarde ...</span>
              </div>
            </v-card-text>
          </v-card>
          <v-divider class="mb-5"></v-divider>
          <div v-for="transportadora in transportadoras" :key="transportadora.cnpj">
            <v-card outlined class="app-card" v-if="transportadoras.length">
              <v-card-text class="app-card-content">
                <v-row no-gutters>
                  <v-col :md="4" :sm="12" :xs="12" cols="12">
                    <h5 class="fieldInfo">
                      <strong>Razão Social:</strong>
                      {{ transportadora ? transportadora.razaoSocial : "-" }}
                    </h5>
                  </v-col>
                  <v-col :md="4" :sm="12" :xs="12" cols="12">
                    <h5 class="fieldInfo">
                      <strong>Nome Fantasia:</strong>
                      {{ transportadora ? transportadora.nomeFantasia : "-" }}
                    </h5>
                  </v-col>
                  <v-col :md="4" :sm="12" :xs="12" cols="12">
                    <h5 class="fieldInfo">
                      <strong>CNPJ:</strong>
                      {{ transportadora ? formatCpfCnpj(transportadora.cnpj) : "-" }}
                    </h5>
                  </v-col>
                  <v-col :md="4" :sm="12" :xs="12" cols="12">
                    <h5 class="fieldInfo">
                      <strong>Situação Cadastral:</strong>
                      <v-chip
                        v-if="transportadora"
                        class="ma-2"
                        color="green"
                        text-color="white"
                      >CADASTRADA</v-chip>
                      <span v-else>-</span>
                    </h5>
                  </v-col>
                  <v-col :md="4" :sm="12" :xs="12" cols="12">
                    <h5 class="fieldInfo">
                      <strong>Áreas de Atuação:</strong>
                      {{ transportadora ? transportadora.areaAtuacao : "-" }}
                    </h5>
                  </v-col>
                  <v-col :md="4" :sm="12" :xs="12" cols="12">
                    <h5 class="fieldInfo">
                      <strong>Serviços:</strong>
                      {{ transportadora ? transportadora.servico : "-" }}
                    </h5>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
          <h5 v-if="result" class="notfound">
            Transportadora não localizada ou não está ativa em nossa base de
            dados.
          </h5>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import TransportadoraService from "@/services/transportadora.service";
import * as _ from "lodash";
import {
  formatAlphanumericCNPJ,
  normalizeAlphanumericCNPJ
} from "@/helpers/cnpj-alphanumeric.validator";
import { formatCpfCnpjDisplay } from "@/helpers/cpf-cnpj-display";

export default {
  name: "ConsultaTransportadoraRegularizadas",
  components: {
    VueRecaptcha
  },
  metaInfo: {
    title: "Consulta Transportadoras Regularizadas - Central de Serviços"
  },
  data: () => ({
    isLoading: false,
    filters: [
      { key: "CNPJ", name: "CNPJ" },
      { key: "NOME_FANTASIA", name: "Nome Fantasia" },
      { key: "RAZAO_SOCIAL", name: "Razão Social" },
      { key: "PLACA", name: "Placa" }
    ],
    form: {
      filter: "CNPJ",
      term: null,
      recaptcha: null
    },
    rules: {
      required: value => !!value || "Esse campo deve ser preenchido",
      pattern: value =>
        !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
        "Esse campo está fora do padrão"
    },
    siteKey: VUE_APP_RECAPTCHA_KEY,
    result: false,
    transportadoras: [],
    transportadoraItems: []
  }),
  computed: {
    formattedCnpj: {
      get() {
        return this.form.term;
      },
      set(value) {
        this.form.term = formatAlphanumericCNPJ(value);
      }
    }
  },
  methods: {
    formatCpfCnpj(value) {
      return formatCpfCnpjDisplay(value);
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        this.result = false;
        const body = {
          cnpj:
            this.form.filter === "CNPJ"
              ? normalizeAlphanumericCNPJ(this.form.term)
              : null,
          razaoSocial:
            this.form.filter === "RAZAO_SOCIAL" ? this.form.term : null,
          nomeFantasia:
            this.form.filter === "NOME_FANTASIA" ? this.form.term : null,
          placa:
            this.form.filter === "PLACA"
              ? this.form.term.replace("-", "")
              : null
        };
        TransportadoraService.consultaTransportadoraRegularizada(
          body
        ).subscribe(
          res => {
            this.transportadoras = _.unionBy(res, "cnpj");
            this.result = this.transportadoras.length ? false : true;
            this.isLoading = false;
          },
          err => {
            this.result = true;
            this.isLoading = false;
          }
        );
      }
    },
    loadTransportadorasItems() {
      const body = {
        cnpj: null,
        razaoSocial: null,
        nomeFantasia: null,
        placa: null
      };
      // this.isLoading = true;
      TransportadoraService.consultaTransportadoraRegularizada(body).subscribe(
        res => {
          this.transportadoraItems = _.unionBy(res, "cnpj");
          // this.result = this.transportadoras.length ? false : true;
          //this.isLoading = false;
        },
        err => {
          // this.result = true;
          //this.isLoading = false;
        }
      );
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    }
  },
  watch: {
    "form.filter": function(newValue, oldValue) {
      if (newValue) {
        this.form.term = null;
      }
    }
  },
  mounted() {
    this.loadTransportadorasItems();
  }
};
</script>

<style lang="scss" scoped>
.recaptcha-input {
  margin-top: -41px;
}
.notfound {
  text-align: center;
  font-weight: 400 !important;
}
.fieldInfo {
  text-transform: uppercase;
  font-size: 15px !important;
  & strong {
    font-size: 15px !important;
  }
}
</style>
